import Assets from './Assets';
import Brief from './Brief';
import Ideas from './Ideas';

export default function About({ challenge }) {
  return (
    <div className="gap-5 grid grid-cols-1 tablet:grid-cols-2 tablet:grid-rows-2">
      <Brief challenge={challenge} />
      <Assets challenge={challenge} />
      <Ideas challenge={challenge} />
    </div>
  );
}
